import { SECONDS_IN_DAY, SECONDS_IN_HOUR, SECONDS } from 'src/app/constants';

export function formatTime(seconds: number): string {
  const days: number = Math.floor(seconds / SECONDS_IN_DAY);
  const hours: number = Math.floor((seconds % SECONDS_IN_DAY) / SECONDS_IN_HOUR);
  const minutes: number = Math.floor(((seconds % SECONDS_IN_DAY) % SECONDS_IN_HOUR) / SECONDS);
  const secs: number = Math.floor(seconds % SECONDS);

  return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
}

export function pad(num: number): string {
  return num < 10 ? `0${num}` : `${num}`;
}
